import {
  OpcoesRepositorioBaseComFiltragemDeLeitura,
  ParametrosPadraoParaRequisicoesGet,
  RepositorioBase,
} from ".."
import { AxiosRequestConfig } from "axios"
import { usarSerializador } from "@/composable/UsarSerializador/usarSerializador"

const { paramsSerializer } = usarSerializador()

export class RepositorioBaseComFiltragemDeLeitura extends RepositorioBase {
  public parametrosPadrao: ParametrosPadraoParaRequisicoesGet

  public constructor(
    opcoesRepositorioComFiltragem: OpcoesRepositorioBaseComFiltragemDeLeitura = {}
  ) {
    super(opcoesRepositorioComFiltragem)
    this.parametrosPadrao = opcoesRepositorioComFiltragem.parametrosPadrao || {}

    this._inicializarInterceptadorParaLeitura()
  }

  private _inicializarInterceptadorParaLeitura = () => {
    this.instance.interceptors.request.use(this._manipularParametrosDeLeitura)
  }

  private _manipularParametrosDeLeitura = (config: AxiosRequestConfig = {}) => {
    const definirParametrosPadrao = () => {
      const naoEhUmaRequisicaoGet = config.method !== "get"

      if (naoEhUmaRequisicaoGet) {
        return {}
      }

      return {
        deletado: "igual.false",
        "ordenar-por": ["desc.ativo", "asc.nome"],
      }
    }

    const definirParametrosManipulados = {
      ...definirParametrosPadrao(),
      ...this.parametrosPadrao,
    }
    const definirParametrosDaRequisicao = config.params || {}

    config.params = {
      ...definirParametrosManipulados,
      ...definirParametrosDaRequisicao,
    }
    config.paramsSerializer = paramsSerializer

    return config
  }
}
